/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const cctv: CommunityData = {
  code: "cctv",
  inviteCode: "cctv",
  name: "CCTV",
  thumbnail: "https://media.werz.at/web/%D1%81%D1%81tv-thumbnail.jpg",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/cct-181`,
  socials: {
    instagramLink: "https://www.instagram.com/cctvsthlm/",
    soundcloudLink: "https://soundcloud.com/cctvsthlm",
  },
  styles: {
    global: {
      counterColor: "#E32521",
      alternativeLogo: {
        src: "/assets/customizations/cctv/white-logo.svg",
        styles: "w-[97px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      logo: {
        src: "/assets/customizations/cctv/logo.svg",
        styles: "w-[129px] h-[129px]",
      },
      bgColor: "#b2b2b2",
      asideStyles: "",
      asideBg: "#EB0F21",
      contentBg: "linear-gradient(0deg,#F0F5EB,#F0F5EB),#FFB062",
      contentBoxShadow: "shadow-[0px_4px_40px_rgba(231,0,23,0.64)]",
      bgDesktop: "/assets/images/cctv-bg.png",
      bgMobile: "/assets/images/cctv-bg.png",
      mainFont: "font-['Graphik']",
      primaryButton:
        "w-full sm:w-fit !px-6 !h-[52px] bg-[#E32521] !text-[16px] !leading-[1] font-['Graphik'] !font-medium !text-white border border-[#E32521] whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#ffffff",
      separator: "border-[#FFB5BB] border-t",
      item: "font-['Graphik'] text-[18px] leading-[18px] h-[40px] flex items-center sm:justify-start justify-center font-medium uppercase text-white !pt-2 ",
      itemSelected: "bg-[#C40010] text-white",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles:
        "font-['Graphik'] uppercase text-[#E32521] text-[24px] font-medium leading-[24px] pb-2",
      announcements: {
        customBg: "bg-[#E32521]",
        lg: {
          title: "text-[20px] leading-[1]",
          subtitle: "text-[9px] leading-[1]",
        },
        sm: {
          title: "text-[20px] sm:text-[14px] leading-[1]",
          subtitle: "text-[9px] leading-[1]",
        },
      },
      event: {
        title: "text-[14px] !font-medium leading-[0.8] sm:leading-[1] text-[#E32521]",
        subtitle: "text-[14px] leading-[18px] text-[#E32521]",
      },
      shop: {
        title: "text-[20px] leading-[1] font-medium font-['Graphik'] text-[#E32521] uppercase",
        text: "text-[14px] leading-[18px] text-[#E32521]",
        customShopImage: "/assets/customizations/cctv/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-['Graphik'] uppercase text-[#E32521] text-[32px] font-medium leading-[32px]",
      title:
        "font-['Graphik'] uppercase text-[#E32521] text-[24px] font-medium leading-[24px] pb-2",
      description: "text-[9px] leading-[1]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title:
        "font-['Graphik'] uppercase text-[#E32521] text-[24px] font-medium leading-[24px] pb-2",
      description: "text-[9px] leading-[1]",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle: "text-[32px] font-medium leading-10 font-['Graphik'] text-[#E32521] uppercase",
      sectionSubtitle: "text-[16px] leading-[18px] font-medium text-[#E32521]",
      text: "text-[14px] leading-[18px] text-[#E32521]",
      separator: "border-b border-[#E32521] border-opacity-40",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#E32521",
        strokeColor: "border-[#E32521]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "text-[32px] font-medium leading-10 font-['Graphik'] text-[#E32521] uppercase",
        subtitle: "text-[16px] leading-[18px] font-medium text-[#E32521]",
      },
      ticket: {
        counterContainer: "",
        title: "text-[24px] leading-7 font-['Graphik'] text-[#E32521]",
        description: "text-base leading-5",
        text: "text-[14px] leading-[18px] text-[#E32521]",
        price: "text-[24px] leading-7 text-[#E32521]",
        quantity: "text-[20px] leading-5 font-medium text-[#E32521]",
      },
    },
  },
}

export default cctv
